import { z } from 'zod';
import { defineEndpoint } from '../define';
import { RoleSchema } from './list';

export const UpdateRoleBodySchema = z
  .object({
    name: z.string().trim().min(1).max(100).optional(),
    permissions: z
      .array(z.string())
      .transform((keys) => [...new Set(keys)])
      .optional(),
  })
  .refine((b) => b.name !== undefined || b.permissions !== undefined, {
    message: 'At least one editable field must be present',
  });

export type UpdateRoleBody = z.input<typeof UpdateRoleBodySchema>;

export const UpdateRoleResponseSchema = z.object({
  data: RoleSchema,
});

export const updateRole = defineEndpoint({
  method: 'PATCH',
  path: '/v1/roles/:roleId',
  params: z.object({ roleId: z.string().uuid() }),
  query: z.object({}),
  body: UpdateRoleBodySchema,
  response: UpdateRoleResponseSchema,
});
